<ng-select
  [class.readonly]="readonly"
  [items]="items"
  [(ngModel)]="initialValue"
  [placeholder]="placeholder"
  [clearable]="clearable"
  [disabled]="disabled"
  [bindLabel]="displayField"
  bindValue="id"
  [multiple]="multiple"
  [addTag]="addTag"
  [addTagText]="addTagText"
  [readonly]="readonly"
  (search)="onSearch($event?.term)"
  (change)="selectItems($event)"
  [virtualScroll]="virtualScroll"
  (clear)="multiple ? itemsSelected.emit([]) : itemSelected.emit(null)"
  (scrollToEnd)="endReached()"
  [trackByFn]="trackByFn"
  [appendTo]="appendTo"
  (open)="open.emit()"
  (close)="onDropdownClose(); close.emit()"
  [searchFn]="searchFn"
  (blur)="onDropdownClose(); blur.emit($event)"
  (focus)="focused.emit($event)"
  [keyDownFn]="keyDownFn"
>
  <ng-template ng-option-tmp let-item="item">
    <ng-container *ngIf="showTooltip; else noTooltip">
      <div class="option-with-tooltip"
           nbTooltip="{{ item?.[displayField] }}"
           [nbTooltipPlacement]="tooltipPlacement"
           nbTooltipStatus="primary"
           nbTooltipTrigger="hover">
        <span [ngClass]="{'line-through': item?.lineThrough === true, 'disabled-option': item?.disabled === true}" [innerHTML]="highlightText(item?.[searchByField])"></span>
      </div>
    </ng-container>
  
    <ng-template #noTooltip>
      <div class="option-without-tooltip" [nbSpinner]="loadingItems">
        <span [ngClass]="{'line-through': item?.lineThrough === true, 'disabled-option': item?.disabled === true}" [innerHTML]="highlightText(item?.[searchByField])"></span>
      </div>
    </ng-template>
  </ng-template>
  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
    <div *ngIf="!loadingItems" class="ng-option disabled">Nu s-au găsit rezultate pentru "
      <mark>{{ searchTerm }}"</mark>
    </div>
    <div *ngIf="loadingItems" class="ng-option disabled" [nbSpinner]="true">Se încarcă
    </div>
  </ng-template>
</ng-select>
